/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IntegratedDemoUser } from "../models/IntegratedDemoUser";
import type { LinkStartResponse } from "../models/LinkStartResponse";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class LineService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Start Linking
   * LINE 連携を開始する
   *
   * 1. state 生成（32文字 URL-safe Base64）
   * 2. LineOAuthStateTable に保存（TTL 10分）
   * 3. LINE 認可 URL を返却
   * @returns LinkStartResponse Successful Response
   * @throws ApiError
   */
  public startLink(): CancelablePromise<LinkStartResponse> {
    return this.httpRequest.request({
      method: "POST",
      url: "/auth/start"
    });
  }

  /**
   * Get Link Status
   * LINE 連携状態を取得
   *
   * IntegratedDemoUserTable から LINE 連携情報を取得。
   * 連携済みかどうかは line_user_id や line_linked_at の有無で判定。
   * @returns any Successful Response
   * @throws ApiError
   */
  public getLinkStatus(): CancelablePromise<IntegratedDemoUser | null> {
    return this.httpRequest.request({
      method: "GET",
      url: "/link-status"
    });
  }

  /**
   * Unlink
   * LINE 連携を解除
   *
   * IntegratedDemoUserTable から LINE 情報を削除し、
   * UserConfig の line_delivery_enabled を無効化する。
   * @returns any Successful Response
   * @throws ApiError
   */
  public unlink(): CancelablePromise<IntegratedDemoUser | null> {
    return this.httpRequest.request({
      method: "POST",
      url: "/unlink"
    });
  }
}
